import { IDefaultMeControlStyles } from './DefaultMeControl.types';
import { linkColor, msGridUnit, linkHoverColor } from '../constants';

export const defaultMeControlPanelStyles: IDefaultMeControlStyles = {
  section: {
    padding: `${msGridUnit}px 0`
  },
  link: {
    color: linkColor,
    selectors: {
      ['a:hover']: {
        color: linkHoverColor
      },
      ['a:focus']: {
        textDecoration: 'underline'
      }
    }
  }
};
